const services = [
  {
    title: "Talent augmentation",
    heading:
      "Supporting organizations to build the right teams for expedited implementation",
    subHeading:
      "Enterprise organizations can accelerate capability to cope with emerging and next generation technologies by augmenting teams and injecting tech talent into the existing teams to scale and grow. With a highly diversified technology talent and enterprise accustomed program teams, we seamlessly augment existing or new engagements while absorbing the onboarding and training risks.​",
  },
  {
    title: "Mobility",
    heading: "Intuitive and interactive applications to scale your business​",
    subHeading:
      "At Confiz, we are proficient in developing Android, iOS, native, hybrid, cross platform mobile applications as well as progressive web apps, enabling and empowering businesses. We leverage industry best practices, latest technology and tools and our vast industry knowledge to create high performing applications that deliver on their business promise. ​",
  },
  {
    title: "Solution strategy",
    heading:
      "From conception to manifestation, establish the solution foundation and strategy roadmap towards end goals",
    subHeading:
      "It goes without saying that strategy lies at the foundation of every solution. Whether you are a startup with an idea or an enterprise with a problem statement, we dig deep to understand the situation, recommend how you should go about formulating the solution to the problem and roadmap how this will eventually evolve into a solution manifesto. Our consultants collaborate with you to chalk out the whole journey towards an end goal that truly delivers on your vision.​",
  },
  {
    title: "Managed services",
    heading:
      "Full-service management of IT infrastructure to help businesses run smarter ​",
    subHeading:
      "Optimal use and delivery of software requires that the service and infrastructure on which it runs must be managed and refurbished with time. We take this responsibility off your shoulders on to ours, so you can focus on your strategic goals. From implementing updates, performing upgrades, to maintaining and optimizing applications, our consultants curate a custom collaboration so you always have an optimally-functional platform.​",
  },
  {
    title: "Quality assurance",
    heading:
      "Uncompromising testing protocols to advance the highest quality standard criterion",
    subHeading:
      "Build and deploy robust bug-free products and softwares as we conduct end-to-end testing of your infrastructure, applications, and data. QA doesn't just cover software testing. We do a thorough run including manual functional testing, automated testing, systems stress testing, system load testing, systems security testing, performance testing, etc. We rigorously test all applications against strictly established protocols and agile testing methodologies to provide your software with a 360º quality assurance.​",
  },
];

export default services;
